import React, { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import camelize from "../../../../global/utils/camelize";
import "./TituloSaludo.css";
import { GlobalContext } from "../../../../global/context/Provider";

const TituloSaludo = () => {
   // Cambio de contexto
   const {
    authState,
  } = useContext(GlobalContext);


  const nameCamelized = () => {
    let name = authState.auth.data.paciente.nombre;
    return camelize(name);
  };

  return (
    <React.Fragment >
      <div className="ptur-saludo-container">
        <span className="rb24b c-black10">
          Hola {nameCamelized()},{" "}
          <span className="rb24t">¿Cómo te podemos ayudar?</span>
        </span>
      </div>
    </React.Fragment>
  );
};

export default TituloSaludo;
